import { createElementBlock as a, openBlock as t, createElementVNode as o } from "vue";
const n = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 21 21"
};
function r(l, e) {
  return t(), a("svg", n, [...e[0] || (e[0] = [
    o("path", {
      fill: "currentColor",
      d: "M16.875 5.624h-2.74q.046-.038.09-.078A2.3 2.3 0 0 0 15 3.872a2.546 2.546 0 0 0-2.622-2.623 2.3 2.3 0 0 0-1.675.774c-.292.339-.529.72-.703 1.132a4.3 4.3 0 0 0-.703-1.132 2.3 2.3 0 0 0-1.675-.774A2.55 2.55 0 0 0 5 3.872a2.3 2.3 0 0 0 .774 1.674q.045.038.092.078H3.125a1.25 1.25 0 0 0-1.25 1.25v2.5a1.25 1.25 0 0 0 1.25 1.25v5a1.25 1.25 0 0 0 1.25 1.25h4.688a.31.31 0 0 0 .312-.312V9.374h-6.25v-2.5h6.25v2.5h1.25v-2.5h6.25v2.5h-6.25v7.188a.313.313 0 0 0 .313.312h4.687a1.25 1.25 0 0 0 1.25-1.25v-5a1.25 1.25 0 0 0 1.25-1.25v-2.5a1.25 1.25 0 0 0-1.25-1.25M6.602 4.61a1.07 1.07 0 0 1-.351-.782A1.3 1.3 0 0 1 7.546 2.5h.038a1.07 1.07 0 0 1 .782.352c.655.74.886 1.968.968 2.728-.763-.08-1.99-.312-2.732-.97m6.797 0c-.741.656-1.972.887-2.734.968.093-.82.35-2.023.976-2.726a1.07 1.07 0 0 1 .78-.351h.04a1.3 1.3 0 0 1 1.289 1.334 1.07 1.07 0 0 1-.352.775z"
    }, null, -1)
  ])]);
}
const v = { render: r };
export {
  v as default,
  r as render
};
